import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, PAGE_SIZE_STORAGE_KEY } from '@/domains/common/pagination.config';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

function isPageSizeOption(size: number): boolean {
    return PAGE_SIZE_OPTIONS.includes(size);
}

const pageSizeSerializer = {
    read: (rawSize: string): number => {
        const size = Number(rawSize);
        return isPageSizeOption(size) ? size : DEFAULT_PAGE_SIZE;
    },
    write: (size: number): string => String(size),
};

export default defineStore('pagination', () => {
    // Storage is left undefined on purpose: VueUse then resolves it inside its own try/catch,
    // so a browser denying local storage falls back to an in-memory ref instead of throwing.
    const pageSize = useStorage(PAGE_SIZE_STORAGE_KEY, DEFAULT_PAGE_SIZE, undefined, {
        serializer: pageSizeSerializer,
        writeDefaults: false,
        listenToStorageChanges: false,
        flush: 'sync',
    });

    function setPageSize(size: number): void {
        if (!isPageSizeOption(size)) {
            console.warn('Ignored a page size outside the available options', size);
            return;
        }
        pageSize.value = size;
    }

    return { pageSize, setPageSize };
});
